import { apiRequest } from '@/lib/api-client';

export interface ScheduleState {
  kind: string;
  enabled: boolean;
  cadenceHours: number;
}

const base = (orgId: string, projectId: string) =>
  `/api/v1/organizations/${orgId}/projects/${projectId}/schedules`;

export const schedulesApi = {
  list: (orgId: string, projectId: string) => apiRequest<ScheduleState[]>(base(orgId, projectId)),

  toggle: (orgId: string, projectId: string, kind: string, enabled: boolean) =>
    apiRequest<ScheduleState>(`${base(orgId, projectId)}/${kind}`, {
      method: 'POST',
      body: { enabled },
    }),
};

/** Shared query key so every ScheduleToggle on a page reads one fetch. */
export const schedulesQueryKey = (orgId: string, projectId: string) =>
  ['schedules', orgId, projectId] as const;
